export default {
  // 自媒体号详细信息接口
  getSelfMediaFreChannel: '/member/anonymous/amc/getSelfMediaFreChannel',
  // 媒体号文章分类下的文章列表接口
  findContentPageByFreChannelId: '/member/anonymous/amc/findContentPageByFreChannelId',
  // 查询是否订阅
  isSubscribe: '/member/anonymous/amc/isSubscribe',
  // 订阅
  subscribeSelfMedia: '/member/anonymous/amc/subscribeSelfMedia',
  // 取消订阅
  unSubscribeSelfMedia: '/member/anonymous/amc/unSubscribeSelfMedia',
  // 留言
  listSelfMediaMessages: '/member/anonymous/amc/listSelfMediaMessages',
  // 新增留言
  addSelfMediaMessages: '/member/anonymous/amc/saveSelfMediaMessages',
  // 删除自己留言
  deleteSelfMediaMessages: '/member/anonymous/amc/deleteSelfMediaMessages',
}